import React from "react";

const AuthForm = ({ title, children }) => {
    return (
        <div className="flex-1 flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 px-4 py-8">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl w-full max-w-2xl">
                <h2 className="text-3xl font-bold text-center text-gray-800">{title}</h2>
                <div className="mt-6 space-y-4 font-['Archivo']">{children}</div>
            </div>
        </div>
    );
};

export default AuthForm;
